<template>
	<!-- page menu sökresultat popover -->
	<div @click.self="this.$emit('hideAllPageMenu')"
		style="border-top:10px solid white;border-bottom:10px solid white;padding-bottom:0px;overflow: hidden;max-height: min(calc(100vh - 200px), 820px);">


		<div v-if="!this && !this.productTypeSelected" class="center center-padding">
			<ProductTypeView />
		</div>


		<div>
			<!-- sätter en egen höjd med plats för footer -->
			<div id="result-view" class="center-padding center" style=" ">

				<div class="flexcenter" style="align-items:start;justify-content:stretch;margin-bottom:0px;">

					<!--wrapper product grid -->
					<SearchResultProductList :model="this.model" style="" :parentTitle="this.title"
						@showProductDetails="((product) => { this.$emit('showProductDetails', product) })" />

					<div class="desktop"
						style="width:33%;min-width:420px;flex-grow:1; position:sticky;top:0px;background:var(--grey-1);border-right: 1px solid var(--grey-2);">
						<!-- höger kolumn, sökresultat position:sticky;top:0px; -->
						<div>

							<!-- tillverkare -->
							<SearchManufactorView
								@searchManufactorSelected="((manufactor) =>  this.$emit('searchManufactorSelected', manufactor))" />
							<!-- kategorier -->
							<SearchCategoryView
								@searchCategorySelected="((category) => this.$emit('searchCategorySelected', category))" />
							<!-- mc-modeller -->
							<SearchMcView @searchMcSelected="((mc) => this.$emit('searchMcSelected', mc))" />
						</div>
					</div>
				</div>
			</div>

			<!-- footer med product type-->
			<div v-if="this.productTypeModel?.selected" class="center-padding center link" style="height:40px;color:white;"
				@click="this.footerPressed()">
				<div class="flexcenter"
					style="justify-content: center;border-radius: 5px;padding:5px;background:var(--bg-message);width:calc(100% - 20px);">
					<b>Stäng sökning och visa resultatet</b>
				</div>
				<Icon fileName="w3_circle_down_white" style="width:25px;height:25px;margin-left:10px;" />

			</div>


			<div v-if="!this.productTypeModel?.selected" class="center-padding center flexcenter link"
				style="height:40px;background:var(--grey-3);justify-content: center;border-radius: 5px;">
				<b>Hittade du inte vad du sökte?</b>
				<Button label="Cykel" @click.stop="this.routerShowProductListForUrlKey('cykel')" />
				<Button label="MC" @click.stop="this.routerShowProductListForUrlKey('mc')" />
				<Button label="Olja" @click.stop="this.routerShowProductListForUrlKey('oil')" />
			</div>
		</div>
	</div>
</template>
<script>

//import { pageMixin } from "@/mixins/pageMixin.js";
//import { productSearchMixin } from "@/mixins/productSearchMixin.js";
import SearchResultProductList from "./searchResult/SearchResultProductList.vue";
import SearchManufactorView from "./searchResult/SearchManufactorView.vue";
import SearchCategoryView from "./searchResult/SearchCategoryView.vue";
import SearchMcView from "./searchResult/SearchMcView.vue";
import { STORE_ACTION, STORE_COMMIT, STORE_GETTER } from "../../store/store";
import ProductTypeView from "./ProductTypeView.vue";

import { routerMixin } from "@/mixins/routerMixin.js";

export default {
	name: "SearchPopoverView",
	components: { SearchResultProductList, SearchManufactorView, SearchCategoryView, SearchMcView, ProductTypeView },
	mixins: [routerMixin],
	props: {
		model: Object

	},
	data() {
		return {
			//autoSearch: false,
			//tableConfigKey: "searchProductList",
		};
	},
	computed: {

		title(){
			return this.parentTitle + "\n" + "SearchResultProductList"
		},

		searchProductConfig() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},
		
		productTypeSelected(){
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED]
		},

		productTypeModel() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL];
		},




	},
	watch: {
		
		"searchProductConfig.manufactor": { // FP: anropas från resultatlistan i popover 
			handler(manufactor) {

				//this.resetScrollLimit()



				const searchProductConfig = this.searchProductConfig
				searchProductConfig.manufactor = manufactor
				this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)
				//this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL);
				//this.enterPressed()
				//this.$emit("enterPressed");
				this.rebuildSearchModel();
			}
		},

		"searchProductConfig.category": {
			handler(category) {

				console.log('FP: category: ', category);

				//this.resetScrollLimit()

				const searchProductConfig = this.searchProductConfig
				searchProductConfig.category = category
				this.$store.commit(STORE_COMMIT.SET_SEARCH_PRODUCT_CONFIG, searchProductConfig)

				//this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL);
				//this.enterPressed()
				//this.$emit("enterPressed");
				this.rebuildSearchModel();
			}
		},
		"searchProductConfig.year": {
			handler(year) {

				console.log('FP: year: ', year);
				this.rebuildSearchModel();
				//this.resetScrollLimit()
				//this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL);
				//this.enterPressed()
				//this.$emit("enterPressed");
			}
		},
		"searchProductConfig.mc": {
			handler(mc) {

				console.log('FP: mc: ', mc);
				this.rebuildSearchModel();
				//this.resetScrollLimit()
				//this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL);
				//this.enterPressed()
				//this.$emit("enterPressed");
			}
		},
		"searchProductConfig.brand": {
			handler(brand) {

				console.log('FP: brand: ', brand);
				//this.resetScrollLimit()
				
				//this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL);
				//this.enterPressed()
				//this.$emit("enterPressed");
				this.rebuildSearchModel();
			}
		},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });

		rebuildSearchModel(){
			//alert("rebuild")
			//FP: 2026: CO2: this.$store.commit(STORE_COMMIT.REBUILD_SEARCH_MODEL);
			this.$store.dispatch({ type: STORE_ACTION.REBUILD_SEARCH_MODEL_ACTION }).then(() => {
				this.$emit("resetScrollLimit");
				this.$emit("enterPressed");
			})
			

		},

		footerPressed(){
			// om vi inte är på produktsidan så navigera till den

			

			if (this.$route.name == "Products"){
				this.$emit('closePopoverPressed')
			}else{
				this.routerShowProductList()
			}
			
		}
		/*resetScrollLimit() {
			this.$emit("resetScrollLimit");
		}*/

	},
	created() {

	}
};
</script>

<style scoped>

div#result-view{
	max-height: min(calc(100vh - 300px), 720px);
	overflow: scroll;
}

@media (max-width: 768px) {
		div#result-view {
				max-height: min(calc(85vh - 300px), 720px);
				overflow: scroll;
			}

}

</style>